"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _question = _interopRequireDefault(require("cccisd-icons/question4"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: '1em'
    },
    className: "panel panel-default panel-body"
  }, /*#__PURE__*/_react["default"].createElement(_question["default"], {
    spaceRight: true
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      fontWeight: '300'
    }
  }, props.text));
};